import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { BulkOrderService } from '../../../../SGRE-custom/bulk-order-page/services/bulk-order.service';
import { CmsParagraphComponent } from '@spartacus/core';

@Component({
    selector: 'app-bulkorder-upload-paragraph',
    templateUrl: './bulkorder-upload-paragraph.component.html',
    styleUrl: './bulkorder-upload-paragraph.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BulkorderUploadParagraphComponent {

  /** Old Implementation
  public userRoles: any[];
  role: string;
  public componentData: any; */

  /** OOTB Implementation */
  @Input() data: Observable<CmsParagraphComponent>;
  currentpage$: Observable<number>;

  constructor(
    private bulkservice: BulkOrderService,
  ) { }

  /** OOTB Implementation */
  ngOnInit(): void {
    this.getCurrentPage();
  }

  getCurrentPage(): void {
    this.currentpage$ = this.bulkservice.getNextValue();
  }

  /** Old Implementation
  ngOnInit(): void {
    this.currentpage$=this.bulkservice.isNext$;
    this.getUserRole();
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }

  getUserRole() {
    this.store.pipe(select(selectUserRoles)).subscribe((userRoles) => {
      this.userRoles = userRoles;
    });
    let userRole: any = ''
    userRole = this.userRoles;
    if (userRole?.includes("Requester") && !userRole?.includes("Purchaser")) {
      this.role = 'Requester';
    }
    else if (userRole?.includes("Purchaser") && !userRole?.includes("Requester")) {
      this.role = 'Purchaser';
    }
    else if (userRole?.includes("Purchaser") && userRole?.includes("Requester")) {
      this.role = 'Purchaser&Requester'
      //this.role='Purchaser&Requester'
    }
  } */
}